import React from "react";
import {useThemeStore} from "../../stores/themeStore";
import './DeskingPage.scss'

const LENDERS = 6
const ROWS = 14

// Themed shimmer block — width/height passed in; reuses the page tokens.
const Skel = ({ w, h, radius }) => (
    <span className={'desking-skel'} style={{ width: w, height: h, borderRadius: radius }}/>
)

// Mirrors the real DeskingPage (topbar + filter bar + matrix grid) so the
// loading state matches the design and lines up with the loaded content.
export const DeskingPageLoading = () => {
    const theme = useThemeStore((state) => state.theme)

    return (
        <div id="DeskingPage" data-theme={theme}>
            <div className={'desking-panel'}>

                {/* Topbar */}
                <div className={'desking-topbar'}>
                    <Skel w={260} h={15}/>
                    <Skel w={52} h={20} radius={7}/>
                </div>

                {/* Filter bar */}
                <div className={'desking-filter-bar'}>
                    <Skel w={150} h={28}/>
                    <Skel w={120} h={28}/>
                    <Skel w={120} h={28}/>
                    <Skel w={180} h={28}/>
                </div>

                {/* Matrix grid */}
                <div className={'desking-scroll-container'}>
                    <table>
                        <thead>
                            <tr>
                                <th className={'term th-term'}><Skel w={32} h={10}/></th>
                                <th className={'tier th-tier'}><Skel w={24} h={10}/></th>
                                {[...Array(LENDERS)].map((_, i) => (
                                    <th key={i}><Skel w={92} h={12}/></th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {[...Array(ROWS)].map((_, r) => {
                                const groupStart = r % 4 === 0
                                return (
                                    <tr key={r} className={groupStart ? 'group-start' : undefined}>
                                        <td className={'term td-term'}>
                                            {groupStart && <Skel w={22} h={16}/>}
                                        </td>
                                        <td className={'tier td-tier'}><Skel w={18} h={10}/></td>
                                        {[...Array(LENDERS)].map((_, c) => (
                                            <td className={'quote'} key={c}>
                                                {/* sparse, like a real quote matrix */}
                                                {(r * 7 + c * 3) % 5 !== 0 &&
                                                    <span className={'desking-skel desking-skel--chip'}/>}
                                            </td>
                                        ))}
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}
